import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row, Tooltip,
  UncontrolledTooltip
  , Spinner
} from 'reactstrap';
import Select from "react-select";
import * as Yup from "yup";
import { useFormik } from 'formik';
import {deleteEndpoint as onDeleteEndpoint, editPingMonitor, validateRegex} from 'store/actions';
import {Link} from "react-router-dom";

const availableMethods = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD", "OPTIONS"];
const methodOptionsWithBody = ["POST", "PUT", "PATCH"]
const re_url = /https?:\/\/(?:www\.)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b)*(\/[\/\d\w\.-]*)*(?:[\?])*(.+)*/gi

const responseCheckTypes = ["EXACT_JSON", "PARTIAL_JSON", "REGEX"]

const responseCheckTypeOptions = responseCheckTypes.map((value) => ({
  label: value,
  value: value
}));

const availableMethodOptions = availableMethods.map((method) => ({
    label: method,
    value: method,
  }));

const authenticationTypes = ["No Auth", "Basic Auth", "Bearer Token", "JWT Token", "API Key"]

const availableAuthenticationTypes = authenticationTypes.map((authType) => ({
  label: authType,
  value: authType,
}))

const authenticationLocation = ["Parameter", "Headers"]
const availableAuthenticationLocation = authenticationLocation.map((authLocation) => ({
  label: authLocation,
  value: authLocation,
}))

const jwtAlgorithms = ["HS256","HS384","HS512","PS256","PS384","PS512","RS256","RS384","RS512"]
const algorithmWithSecret = ["HS256","HS384","HS512"]

const availableJWTAlgorithms = jwtAlgorithms.map((algorithm) => ({
  label: algorithm,
  value: algorithm,
}))

const OnEditModal = props => {
  const [EndpointDeleteModal, setEndpointDeleteModal] = useState(false);
  const [EndpointForDelete, setEndpointForDelete] = useState(null);
  const [endpointStatus, setEndpointStatus] = useState(false);
  const [parameters, setParameters] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [tooltipAuthRepeat, setToolTipAuthRepeat] = useState(false);
  const [tooltipHeaderRepeat, setToolTipHeaderRepeat] = useState(false);
  const [tooltipPayloadRepeat, setToolTipPayloadRepeat] = useState(false);
  const [tooltipNumberCheck,setToolTipNumberCheck] = useState(false);
  const [touched, setTouched] = useState({
    parameters: [{ key: false, value: false }],
    headers: [{ key: false, value: false }],
  });
  const [regexVerified, setRegexVerified] = useState(null);
  const [testDataValid, setTestDataValid] = useState(null);
  const [regexValidating, setRegexValidating] = useState(null);

  const { testRegex } = useSelector(state => ({
    testRegex: state.PingMonitor.testRegex || {},
  }));

  useEffect(() => {
    setRegexValidating(testRegex?.loading)
    setRegexVerified(testRegex?.valid_regex)
    setTestDataValid(testRegex?.test_string_match)

    if (testRegex?.loading === false && testRegex?.valid_regex === false){
      validation.setFieldError('response_body', "Invalid Regex");
      validation.setFieldTouched('response_body', true, false)
    }

    if(testRegex?.loading === false && testRegex?.test_string_match === false){
      validation.setFieldError("test_json_for_regex", "Given JSON doesnt match with the regex");
      validation.setFieldTouched('test_json_for_regex', true, false)
    }
  }, [testRegex]);

  const handleBlur = (index, field, type) => {
    const updatedTouched = { ...touched };
    updatedTouched[type][index][field] = true;
    setTouched(updatedTouched);
  };

  const validateField = (value) => {
    return value.trim() === '';
  };

  const handleAddRequestParameter = () => {
    setParameters([...parameters, { key: '', value: '' }]);
    setTouched({
      ...touched,
      parameters: [...touched.parameters, { key: false, value: false }],
    });
  };

  const handleAddRequestHeader = () => {
    setHeaders([...headers, { key: '', value: '' }]);
    setTouched({
      ...touched,
      headers: [...touched.headers, { key: false, value: false }],
    });
  };

  const handleDeleteRequestParameter = (index) => {
    const updatedParameters = parameters.filter((_, i) => i !== index);
    const updatedTouched = touched.parameters.filter((_, i) => i !== index);
    setParameters(updatedParameters);
    setTouched({ ...touched, parameters: updatedTouched });
  };

  const handleDeleteRequestHeader = (index) => {
    const updatedHeaders = headers.filter((_, i) => i !== index);
    const updatedTouched = touched.headers.filter((_, i) => i !== index);
    setHeaders(updatedHeaders);
    setTouched({ ...touched, headers: updatedTouched });
  };

  const handleParameterChange = (index, field, value) => {
    const updatedParameters = parameters.map((param, i) =>
      i === index ? { ...param, [field]: value } : param
    );
    setParameters(updatedParameters);
  };

  const handleHeaderChange = (index, field, value) => {
    const updatedHeaders = headers.map((header, i) =>
      i === index ? { ...header, [field]: value } : header
    );
    setHeaders(updatedHeaders);
  };

  const handleEndpointDeleteModal = () => {
    setEndpointDeleteModal(current => !current);
    setEndpointForDelete({"id":validation.initialValues.endpoint_id, "name":validation.initialValues.endpoint_name, "url":validation.initialValues.endpoint_url})
  }

  const cancelUserDeleteModal = () => {
    setEndpointDeleteModal(current => !current);
    setEndpointForDelete(null)
  }

  const handleEndpointDelete = async (endpoint_id) => {
    try {
      const payload = {endpoint_id}
      dispatch(onDeleteEndpoint(payload));
      setEndpointDeleteModal(false);
      setEndpointForDelete(null);
      window.location.reload()
    } catch (error) {
      console.error('Error:', error);
    }
  }
  const dispatch = useDispatch()
  const { isOpen, toggle } = props;
  const { pingMonitorDetail } = useSelector(state => ({
    pingMonitorDetail: state.PingMonitor.pingMointorDetail || {},
  }));

  useEffect(() => {
    if (pingMonitorDetail) {
      setParameters([])
      setHeaders([])
      if ('endpoint_params' in pingMonitorDetail && pingMonitorDetail.endpoint_params !== null) {
        try {
          const requestParams = JSON.parse(pingMonitorDetail.endpoint_params);
          const listParams = Object.entries(requestParams).map(([key, value]) => {
            return {
              "key": key,
              "value": value
            };
          });
          setParameters(listParams || []);
        } catch (error) {
          console.error('Invalid JSON in endpoint_params:', error);
        }
      }
      if ('endpoint_headers' in pingMonitorDetail && pingMonitorDetail.endpoint_headers !== null) {
        try {
          const requestHeaders = JSON.parse(pingMonitorDetail.endpoint_headers);
          const listHeaders = Object.entries(requestHeaders).map(([key, value]) => {
            return {
              "key": key,
              "value": value
            };
          });
          setHeaders(listHeaders || []);
        } catch (error) {
          console.error('Invalid JSON in endpoint_headers:', error);
        }
      }
      setTimeout(()=> {
        const authentication = pingMonitorDetail?.authentication
        if (typeof  authentication !== 'undefined') {
          validation.setFieldValue("authentication_location", authentication?.location || authenticationLocation[0])
          validation.setFieldValue("basic_auth_username", authentication?.username || "")
          validation.setFieldValue("basic_auth_password", authentication?.password || "" )
          validation.setFieldValue("bearer_token", authentication?.token || "")
          validation.setFieldValue("api_key_auth_key", authentication?.key || "")
          validation.setFieldValue("api_key_auth_value", authentication?.value || "")
          validation.setFieldValue("jwt_auth_algorithm", authentication?.algorithm || jwtAlgorithms[0])
          validation.setFieldValue("jwt_auth_payload", authentication?.payload || "")
          validation.setFieldValue("jwt_auth_headers", authentication?.headers || "")
          validation.setFieldValue("jwt_auth_prefix", authentication?.prefix || "")
          validation.setFieldValue("jwt_auth_secret", authentication?.secret || "")
        }
      }, 1000)
    }
  }, [pingMonitorDetail, isOpen]);

  function validateJSON(value) {
    if ( typeof value === 'undefined' || value === null || value === '') return true;
    try {
      JSON.parse(value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function handleJsonChange(userInput){
    if ( typeof userInput === 'undefined' || userInput === null || userInput === "") return "";
    try {
      const parsedJson = JSON.parse(userInput);
      if( parsedJson === null ) return '';
      return userInput
    } catch (error) {
      return userInput
    }
  }

  function lintJson(inputJson){
    if ( typeof inputJson === 'undefined' || inputJson === null || inputJson === '') return "";
    try {
      const parsedJson = JSON.parse(inputJson);
      return JSON.stringify(parsedJson, null, 2); // Formatting JSON with indentation
    } catch (error) {
      return inputJson
    }
  }

  function handleTestRegex(e){
    e.preventDefault()
    setTestDataValid(null)
    setRegexVerified(null)
    if ( ('test_json_for_regex' in validation.errors
        && validation.errors.test_json_for_regex !== 'Given JSON doesnt match with the regex')
      || 'response_body' in validation.errors) {
      return;
    }
    const payload = {
      pattern: validation.values.response_body,
      test_string: validation.values.test_json_for_regex
    }
    dispatch(validateRegex(payload))
  }

  useEffect(() => {
    setEndpointStatus(pingMonitorDetail?.enabled);
  }, [pingMonitorDetail]);
  const domain = window.location.hostname;
  function getPingMonitoringDetails() {
    if(pingMonitorDetail && Object.keys(pingMonitorDetail).length !== 0){
      console.log(pingMonitorDetail.response_body, typeof pingMonitorDetail.response_body)
      return {
        endpoint_id: pingMonitorDetail.id || "",
        endpoint_name: pingMonitorDetail.name || "",
        request_method: pingMonitorDetail.request_method || availableMethods[0],
        endpoint_url: pingMonitorDetail.endpoint || "",
        response_code: pingMonitorDetail.response_success_code || "",
        check_interval: pingMonitorDetail.check_interval_in_minutes || "",
        number_of_checks: pingMonitorDetail.ping_window_size || "",
        failure_count_alert: pingMonitorDetail.down_count_threshold || "",
        authentication_type: pingMonitorDetail.authentication_type || authenticationTypes[0],
        request_timeout: (parseFloat(pingMonitorDetail?.timeout_duration_in_ms || 0)/1000).toFixed(3),
        application_service: props.services.find(service => service.value === pingMonitorDetail.application_service_id)?.value || "",
        request_body: handleJsonChange(pingMonitorDetail.request_body || ""),
        response_body: handleJsonChange(pingMonitorDetail.response_body || ""),
        authentication_location: "",
        basic_auth_username: "",
        basic_auth_password: "",
        bearer_token: "",
        api_key_auth_key: "",
        api_key_auth_value: "",
        jwt_auth_algorithm: jwtAlgorithms[0],
        jwt_auth_payload: "",
        jwt_auth_headers: "",
        jwt_auth_prefix: "",
        jwt_auth_secret: "",
        response_check_type: pingMonitorDetail.response_check_type || responseCheckTypes[0],
        test_json_for_regex: ""
      }
    } else {
      return {
        endpoint_id: "",
        endpoint_name: "",
        request_method: availableMethods[0],
        endpoint_url: "",
        response_code: "",
        check_interval: "",
        number_of_checks: "",
        failure_count_alert: "",
        authentication_type: authenticationTypes[0] ,
        request_timeout: "",
        application_service: "",
        request_body: "",
        response_body: "",
        authentication_location: "",
        basic_auth_username: "",
        basic_auth_password: "",
        bearer_token: "",
        api_key_auth_key: "",
        api_key_auth_value: "",
        jwt_auth_algorithm: jwtAlgorithms[0],
        jwt_auth_payload: "",
        jwt_auth_headers: "",
        jwt_auth_prefix: "",
        jwt_auth_secret: "",
        response_check_type: responseCheckTypes[0],
        test_json_for_regex: ""
      }
    }
  }

  const validation = useFormik({

    enableReinitialize: true,
    initialValues: getPingMonitoringDetails(),
    validationSchema: Yup.object({
      endpoint_name: Yup.string().required("Please Enter Endpoint Name"),
      request_method: Yup.string().required("Please Select Request Method"),
      authentication_type: Yup.string().required("Please Select Request Method"),
      endpoint_url: Yup.string()
        .matches(re_url, "Please Enter a Valid URL")
        .required("Please Enter Endpoint URL"),
      response_code: Yup.number()
        .typeError("Response Code must be a number")
        .integer("Response Code must be an integer")
        .min(100, "Response Code must be at least 100")
        .max(599, "Response Code cannot be more than 599")
        .required("Please Enter Response Code"),
      check_interval: Yup.number()
        .typeError("Check Interval must be a number")
        .positive("Check Interval must be a positive number")
        .required("Please Enter Check Interval"),
      number_of_checks: Yup.number()
        .typeError("Number of checks must be a number")
        .positive("Number of checks must be a positive number")
        .integer("Check Interval must be an integer")
        .required("Please Enter Number of checks"),
      failure_count_alert: Yup.number()
        .typeError("Number of Failures for Alert must be a number")
        .positive("Number of Failures for Alert must be a positive number")
        .required("Please Enter Number of Failures for Alert")
        .test(
        "failure_count_alert",
        "Failures for Alert cannot be greater than Number of Checks",
        function (value) {
          const { number_of_checks } = this.parent;
          return value <= number_of_checks;
        }),
      request_timeout: Yup.number()
        .typeError("Request Timeout must be a number")
        .min(0, "Request timeout can't be negative")
        .lessThan(20, "Request Timeout must be less than 20 seconds")
        .required("Please Enter Request Timeout"),
      request_body: Yup.string()
        .when('request_method', {
          is: (method) => methodOptionsWithBody.includes(method),
          then: Yup.string()
            .required("Please Enter the data in JSON Format")
            .test('is-json', 'Invalid JSON format', validateJSON),
          otherwise: Yup.string().notRequired().nullable()
        }),
      response_body: Yup.string()
        .notRequired()
        .nullable()
        .when('response_check_type', {
          is: (check_type) => check_type === "REGEX",
          then: Yup.string(),
          otherwise: Yup.string().test('is-json', 'Invalid JSON format', validateJSON),
        }),
      basic_auth_username: Yup.string()
        .when('authentication_type', {
          is: (authType) => authType === authenticationTypes[1],
          then: Yup.string()
            .required("Please enter a Username for authentication"),
          otherwise: Yup.string().notRequired()
        }),
      basic_auth_password: Yup.string()
        .when('authentication_type', {
          is: (authType) => authType === authenticationTypes[1],
          then: Yup.string()
            .required("Please enter a Password for authentication"),
          otherwise: Yup.string().notRequired()
        }),
      bearer_token: Yup.string()
        .when('authentication_type', {
          is: (authType) => authType === authenticationTypes[2],
          then: Yup.string()
            .required("Please enter a Token for authentication"),
          otherwise: Yup.string().notRequired()
        }),
      api_key_auth_key: Yup.string()
        .when('authentication_type', {
          is: (authType) => authType === authenticationTypes[4],
          then: Yup.string()
            .required("Please enter a Key for authentication"),
          otherwise: Yup.string().notRequired()
        }),
      api_key_auth_value: Yup.string()
        .when('authentication_type', {
          is: (authType) => authType === authenticationTypes[4],
          then: Yup.string()
            .required("Please enter a Value for authentication"),
          otherwise: Yup.string().notRequired()
        }),
      authentication_location: Yup.string()
        .when("authentication_type", {
          is:(authType) => authType === authenticationTypes[3]  || authType === authenticationTypes[4],
          then: Yup.string()
            .required("PLease enter a Location for authentication"),
          otherwise: Yup.string().notRequired()
        }),
      jwt_auth_algorithm: Yup.string()
        .when('authentication_type', {
          is: (authType) => authType === authenticationTypes[3],
          then: Yup.string()
            .required("Please enter a algorithm for authentication"),
          otherwise: Yup.string().notRequired()
        }),
      jwt_auth_payload: Yup.string()
        .when("authentication_type", {
          is:(authType) => authType === authenticationTypes[3],
          then: Yup.string()
            .required("Please Enter the Payload in JSON Format")
            .test('is-json', 'Invalid JSON format', validateJSON),
          otherwise: Yup.string().notRequired()
        }),
      jwt_auth_headers: Yup.string()
        .when("authentication_type", {
          is:(authType) => authType === authenticationTypes[3],
          then: Yup.string()
            .required("Please Enter the Header in JSON Format")
            .test('is-json', 'Invalid JSON format', validateJSON),
          otherwise: Yup.string().notRequired()
        }),
      jwt_auth_prefix: Yup.string()
        .when('authentication_type', {
          is: (authType) => authType === authenticationTypes[3],
          then: Yup.string()
            .required("Please enter an Prefix for authentication"),
          otherwise: Yup.string().notRequired()
        }),
      jwt_auth_secret: Yup.string()
        .when('authentication_type', {
          is: (authType) => authType === authenticationTypes[3],
          then: Yup.string()
            .required("Please enter an Secret/Key for authentication"),
          otherwise: Yup.string().notRequired()
        }),
      test_json_for_regex: Yup.string()
        .notRequired()
        .nullable()
        .test('is-json', 'Invalid JSON format', validateJSON)
    }),

    onSubmit: (values) => {
      const requestHeaders = headers
        .map(item => ({ [item.key]: item.value }))
        .reduce((acc, curr) => ({ ...acc, ...curr }), {});

      const requestParams = parameters
        .map(item => ({ [item.key]: item.value }))
        .reduce((acc, curr) => ({ ...acc, ...curr }), {});
      let authPayload = {}
      switch (values.authentication_type){
        case authenticationTypes[1]: // Basic Auth
          authPayload = {
            "username": values.basic_auth_username,
            "password": values.basic_auth_password
          };
          break;
        case authenticationTypes[2]: // Bearer Token
          authPayload = {
            "token": values.bearer_token
          };
          break;
        case authenticationTypes[3]:
          authPayload = {
            "location": values.authentication_location,
            "algorithm": values.jwt_auth_algorithm,
            "payload": values.jwt_auth_payload,
            "headers": values.jwt_auth_headers,
            "prefix": values.jwt_auth_prefix,
            "secret": values.jwt_auth_secret
          };
          break;
        case authenticationTypes[4]:
          authPayload = {
            "location": values.authentication_location,
            "key": values.api_key_auth_key,
            "value": values.api_key_auth_value
          };
          break;
      }
      const payload = {
        id: values.endpoint_id,
        name: values.endpoint_name,
        request_method: values.request_method,
        endpoint: values.endpoint_url,
        response_success_code: values.response_code,
        check_interval_in_minutes: values.check_interval,
        timeout_duration_in_s: parseFloat(parseFloat(values.request_timeout).toFixed(3)),
        application_service_id: values.application_service,
        request_body: methodOptionsWithBody.includes(values.request_method)?JSON.parse(values.request_body): null,
        request_params: requestParams,
        request_headers: requestHeaders,
        authentication_type: values.authentication_type,
        authentication: authPayload,
        ping_window_size: values.number_of_checks,
        down_count_threshold: values.failure_count_alert,
        response_check_type: values.response_check_type,
      };
      if (values.response_check_type === "REGEX"){
        payload['response_body'] = typeof values.response_body !== "undefined" && values.response_body.trim() !== "" ? values.response_body : null
      } else {
        payload['response_body'] = typeof values.response_body !== "undefined" && values.response_body.trim() !== "" ? JSON.parse(values.response_body): null
      }

      dispatch(editPingMonitor(payload));
      toggle();
    }
  })

  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#473753',
      position: "absolute",
      zIndex: 200,
      // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100,
    }),
  };

  return (
    <Modal
      size={"xl"}
      isOpen={isOpen}
      toggle={toggle}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          Edit Service
        </ModalHeader>
        <div className="d-flex justify-content-between align-items-start">
        <ModalBody >
          <Form
            className='form-horizontal'
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
            }}
          >
          <Row>
            <Col sm={7}>
            <Row>
              <Col sm={12}>
                <div className="mb-3">
                  <Label htmlFor="endpoint_name">Endpoint Name</Label>
                  <Input
                    id="endpoint_name"
                    name="endpoint_name"
                    type="text"
                    required
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.endpoint_name || ""}
                    invalid={
                      validation.touched.endpoint_name && validation.errors.endpoint_name ? true : false
                    }
                  />
                  {validation.touched.endpoint_name && validation.errors.endpoint_name ? (
                    <FormFeedback type="invalid">{validation.errors.endpoint_name}</FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col sm={4}>
                <div className="mb-3 w-75">
                  <Label htmlFor="request_method">HTTP Request Method</Label>
                  <Select
                    id="request_method"
                    name="request_method"
                    onBlur={validation.handleBlur}
                    value={availableMethodOptions.find(
                      (option) => option.label === validation.values.request_method
                    )}
                    placeholder="Request Method"
                    onChange={(selectedOption) => {
                      validation.setFieldValue("request_method", selectedOption.label);
                    }}
                    options={availableMethodOptions}
                    className="select2-selection col-form-label bg-transparent text-white"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </div>
              </Col>
              <Col sm={4}>
                <div className="mb-3">
                  <Label>Map to Service</Label>
                  {props.services.length > 0 &&
                    <div className="w-75 mt-2">
                      <Select
                        id="application_service"
                        name="application_service"
                        options={props.services}
                        onBlur={validation.handleBlur}
                        placeholder="Map to Service"
                        value={
                          props.services.find(
                            (option) => option.value === validation.values.application_service
                          ) || null
                        }
                        onChange={(selectedOption) => {
                          validation.setFieldValue("application_service", selectedOption.value);
                        }}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            neutral0: '#222736',
                            neutral5: '#485EC4',
                            neutral10: '#485EC4',
                            neutral60: '#ffffff',
                            neutral70: '#ffffff',
                            neutral80: '#ffffff',
                            neutral90: '#ffffff',
                            primary: '#485EC4',
                          },
                        })}
                        styles={customStyles}
                      />

                    </div>
                  }
                </div>
              </Col>
              <Col sm={12}>
                <div className="mb-3">
                  <Label htmlFor="endpoint_url">Endpoint URL</Label>
                  <Input
                    id="endpoint_url"
                    name="endpoint_url"
                    type="text"
                    required
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.endpoint_url || ""}
                    invalid={
                      validation.touched.endpoint_url && validation.errors.endpoint_url ? true : false
                    }
                    placeholder="http://subdomain.domain.top-level-domain/path/to/endpoint"
                  />
                  {validation.touched.endpoint_url && validation.errors.endpoint_url && (
                    <FormFeedback type="invalid">{validation.errors.endpoint_url}</FormFeedback>
                  )}
                </div>
              </Col>
              <Col sm={8}>
                <div className="mb-3">
                  <Label htmlFor="response_code">HTTP Response Code</Label>
                  <Input
                    id="response_code"
                    name="response_code"
                    type="number"
                    required
                    min={100}
                    max={599}
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.response_code || ""}
                    invalid={
                      validation.touched.response_code && validation.errors.response_code ? true : false
                    }
                    placeholder="Response Code for Success"
                  />
                  {validation.touched.response_code && validation.errors.response_code && (
                    <FormFeedback type="invalid">{validation.errors.response_code}</FormFeedback>
                  )}
                </div>
              </Col>
              <Col sm={12}>
                <div className='d-flex align-items-center justify-content-start gap-3 mb-2'>
                  <div className="mb-3 w-50">
                    <Label htmlFor="check_interval">Check Interval in Minutes</Label>
                    <Input
                      id="check_interval"
                      name="check_interval"
                      type="number"
                      required
                      className="input"
                      onChange={validation.handleChange}
                      onBlur={(e)=> {
                        validation.handleBlur(e)
                        if(validation.values.check_interval < 5){
                          validation.setFieldValue('failure_count_alert', 3)
                          validation.setFieldValue('number_of_checks', 5)
                        } else if (validation.values.check_interval < 15){
                          validation.setFieldValue('failure_count_alert', 2)
                          validation.setFieldValue('number_of_checks', 3)
                        } else{
                          validation.setFieldValue('failure_count_alert', 1)
                          validation.setFieldValue('number_of_checks', 1)
                        }
                      }}
                      value={validation.values.check_interval !== undefined && validation.values.check_interval !== null ? validation.values.check_interval : ""}
                      invalid={
                        validation.touched.check_interval && validation.errors.check_interval ? true : false
                      }
                      placeholder="Enter Check Interval in minutes"
                    />
                    {validation.touched.check_interval && validation.errors.check_interval && (
                      <FormFeedback type="invalid">{validation.errors.check_interval}</FormFeedback>
                    )}
                  </div>
                  <div className="mb-3 w-50">
                    <Label htmlFor="request_timeout">Request Timeout in Second</Label>
                    <Input
                      id="request_timeout"
                      name="request_timeout"
                      type="number"
                      required
                      className="input"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.request_timeout !== undefined && validation.values.request_timeout !== null ? validation.values.request_timeout : ""}
                      invalid={
                        validation.touched.request_timeout && validation.errors.request_timeout ? true : false
                      }
                      placeholder="Enter Request Timeout in seconds"
                    />
                    {validation.touched.request_timeout && validation.errors.request_timeout && (
                      <FormFeedback type="invalid">{validation.errors.request_timeout}</FormFeedback>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <div className="mb-3">
                  <Label htmlFor="auth_type">Authentication</Label>
                  <span
                    id="TooltipAuthRepeat"
                    onMouseOver={() => setToolTipAuthRepeat(true)}
                    onMouseLeave={() => setToolTipAuthRepeat(false)}
                    className="alert-icon">
                            <i className="mdi mdi-information-outline text-warning"/>
                          </span>
                  <Tooltip
                    placement="right"
                    isOpen={tooltipAuthRepeat}
                    target="TooltipAuthRepeat"
                    toggle={() => { setToolTipAuthRepeat(!tooltipAuthRepeat); }}
                    style={{
                      border: "2px solid #f1b44c",
                      borderRadius: "10px",
                      backgroundColor: "#2a3042",
                      zIndex: 1
                    }}
                  >
                    Authentication for Endpoints, this will be added to Request/ Parameter headers while sending the request
                  </Tooltip>
                  <Select
                    id="auth_type"
                    name="auth_type"
                    onBlur={validation.handleBlur}
                    value={availableAuthenticationTypes.find(
                      (option) => option.label === validation.values.authentication_type
                    )}
                    placeholder="Authentication Type"
                    onChange={(selectedOption) => {
                      validation.setFieldValue("authentication_type", selectedOption.label);
                    }}
                    options={availableAuthenticationTypes}
                    className="select2-selection col-form-label bg-transparent text-white"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </div>
              </Col>
            </Row>
            {validation.values.authentication_type === authenticationTypes[1] ? //Basic Auth
              <Row className="mb-3">
                <Col sm={6}>
                  <Label>Username</Label>
                  <Input
                    id="basic_auth_username"
                    name="basic_auth_username"
                    type="text"
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.basic_auth_username || ""}
                    invalid={
                      validation.touched.basic_auth_username && validation.errors.basic_auth_username ? true : false
                    }
                    placeholder="Basic Authentication Password"
                  />
                  {validation.touched.basic_auth_username && validation.errors.basic_auth_username && (
                    <FormFeedback type="invalid">{validation.errors.basic_auth_username}</FormFeedback>
                  )}
                </Col>
                <Col sm={6}>
                  <Label>Password</Label>
                  <Input
                    id="basic_auth_password"
                    name="basic_auth_password"
                    type="password"
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.basic_auth_password || ""}
                    invalid={
                      validation.touched.basic_auth_password && validation.errors.basic_auth_password ? true : false
                    }
                    placeholder="Basic Authentication Password"
                  />
                  {validation.touched.basic_auth_password && validation.errors.basic_auth_password && (
                    <FormFeedback type="invalid">{validation.errors.basic_auth_password}</FormFeedback>
                  )}
                </Col>
              </Row>
              : null
            }
            {validation.values.authentication_type === authenticationTypes[2] ? //Bearer Token
              <Row className="mb-3">
                <Col sm={6}>
                  <Label>Bearer Token</Label>
                  <Input
                    id="bearer_token"
                    name="bearer_token"
                    type="text"
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.bearer_token || ""}
                    invalid={
                      validation.touched.bearer_token && validation.errors.bearer_token ? true : false
                    }
                    placeholder="Bearer Token"
                  />
                  {validation.touched.bearer_token && validation.errors.bearer_token && (
                    <FormFeedback type="invalid">{validation.errors.bearer_token}</FormFeedback>
                  )}
                </Col>
              </Row>
              : null
            }
            {validation.values.authentication_type === authenticationTypes[3] ? // JWT Token
              <Row className="mb-3">
                <Col sm={4}>
                  <div className="mb-3">
                    <Label htmlFor="auth_location">Authentication Location</Label>
                    <Select
                      id="auth_location"
                      name="auth_location"
                      onBlur={validation.handleBlur}
                      value={availableAuthenticationLocation.find(
                        (option) => option.label === validation.values.authentication_location
                      )}
                      placeholder="Authentication Location"
                      onChange={(selectedOption) => {
                        validation.setFieldValue("authentication_location", selectedOption.label);
                      }}
                      options={availableAuthenticationLocation}
                      className="select2-selection col-form-label bg-transparent text-white"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          neutral0: '#222736',
                          neutral5: '#485EC4',
                          neutral10: '#485EC4',
                          neutral60: '#ffffff',
                          neutral70: '#ffffff',
                          neutral80: '#ffffff',
                          neutral90: '#ffffff',
                          primary: '#485EC4',
                        },
                      })}
                      styles={customStyles}
                    />
                  </div>
                </Col>
                <Col sm={4}>
                  <div className="mb-3">
                    <Label htmlFor="jwt_auth_algorithm">Algorithm</Label>
                    <Select
                      id="jwt_auth_algorithm"
                      name="jwt_auth_algorithm"
                      onBlur={validation.handleBlur}
                      value={availableJWTAlgorithms.find(
                        (option) => option.label === validation.values.jwt_auth_algorithm
                      )}
                      placeholder="Authentication Location"
                      onChange={(selectedOption) => {
                        validation.setFieldValue("jwt_auth_algorithm", selectedOption.label);
                      }}
                      options={availableJWTAlgorithms}
                      className="select2-selection col-form-label bg-transparent text-white"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          neutral0: '#222736',
                          neutral5: '#485EC4',
                          neutral10: '#485EC4',
                          neutral60: '#ffffff',
                          neutral70: '#ffffff',
                          neutral80: '#ffffff',
                          neutral90: '#ffffff',
                          primary: '#485EC4',
                        },
                      })}
                      styles={customStyles}
                    />
                  </div>
                </Col>
                <Col sm='6' className="mb-3">
                  <Label className="form-label">Header</Label>
                  <span
                    id="TooltipHeaderRepeat"
                    onMouseOver={() => setToolTipHeaderRepeat(true)}
                    onMouseLeave={() => setToolTipHeaderRepeat(false)}
                    className="alert-icon">
                            <i className="mdi mdi-information-outline text-warning"/>
                          </span>
                  <Tooltip
                    placement="right"
                    isOpen={tooltipHeaderRepeat}
                    target="TooltipHeaderRepeat"
                    toggle={() => {
                      setToolTipHeaderRepeat(!tooltipHeaderRepeat);
                    }}
                    style={{
                      border: "2px solid #f1b44c",
                      borderRadius: "10px",
                      backgroundColor: "#2a3042",
                      zIndex: 1
                    }}
                  >
                    Additional header that are added to JWT, along with Algorithm and Type
                  </Tooltip>
                  <textarea
                    style={{fontFamily: 'monospace'}}
                    name="jwt_auth_headers"
                    value={validation.values.jwt_auth_headers || ''}
                    placeholder="Enter Headers in JSON Format"
                    onChange={(event) => {
                      const userInput = event.target.value;
                      validation.setFieldValue("jwt_auth_headers", handleJsonChange(userInput));
                    }}
                    onBlur={(e) => {
                      validation.setFieldValue('jwt_auth_headers', lintJson(validation.values.jwt_auth_headers));
                      validation.handleBlur(e);
                    }}
                    rows={10}
                    className={
                      validation.touched.jwt_auth_headers &&
                      validation.errors.jwt_auth_headers
                        ? 'form-control is-invalid'
                        : 'form-control'
                    }
                  />
                  {validation.touched.jwt_auth_headers &&
                  validation.errors.jwt_auth_headers ? (
                    <FormFeedback type="invalid">
                      {validation.errors.jwt_auth_headers}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col sm='6' className="mb-3">
                  <Label className="form-label">Payload</Label>
                  <span
                    id="TooltipPayloadRepeat"
                    onMouseOver={() => setToolTipPayloadRepeat(true)}
                    onMouseLeave={() => setToolTipPayloadRepeat(false)}
                    className="alert-icon">
                            <i className="mdi mdi-information-outline text-warning"/>
                          </span>
                  <Tooltip
                    placement="right"
                    isOpen={tooltipPayloadRepeat}
                    target="TooltipPayloadRepeat"
                    toggle={() => {
                      setToolTipPayloadRepeat(!tooltipPayloadRepeat);
                    }}
                    style={{
                      border: "2px solid #f1b44c",
                      borderRadius: "10px",
                      backgroundColor: "#2a3042",
                      zIndex: 1
                    }}
                  >
                    Payload always includes Expires(exp), Issued At(iat), Not before (nbf)
                  </Tooltip>
                  <textarea
                    name="jwt_auth_payload"
                    value={validation.values.jwt_auth_payload || ''}
                    style={{fontFamily: 'monospace'}}
                    placeholder="Enter Payload in JSON Format"
                    onChange={(event) => {
                      const userInput = event.target.value;
                      validation.setFieldValue("jwt_auth_payload", handleJsonChange(userInput));
                    }}
                    onBlur={(e) => {
                      validation.setFieldValue('jwt_auth_payload', lintJson(validation.values.jwt_auth_payload));
                      validation.handleBlur(e);
                    }}
                    rows={10}
                    className={
                      validation.touched.jwt_auth_payload &&
                      validation.errors.jwt_auth_payload
                        ? 'form-control is-invalid'
                        : 'form-control'
                    }
                  />
                  {validation.touched.jwt_auth_payload &&
                  validation.errors.jwt_auth_payload ? (
                    <FormFeedback type="invalid">
                      {validation.errors.jwt_auth_payload}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col sm={6}>
                  <Label>Prefix</Label>
                  <Input
                    id="jwt_auth_prefix"
                    name="jwt_auth_prefix"
                    type="text"
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.jwt_auth_prefix || ""}
                    invalid={
                      validation.touched.jwt_auth_prefix && validation.errors.jwt_auth_prefix ? true : false
                    }
                    placeholder={algorithmWithSecret.includes(validation.values.jwt_auth_algorithm)
                      ? "Secret key" : "PASTE CONTENTS THAT BEGINS WITH -----BEGIN PRIVATE KEY"}
                  />
                  {validation.touched.jwt_auth_prefix && validation.errors.jwt_auth_prefix && (
                    <FormFeedback type="invalid">{validation.errors.jwt_auth_prefix}</FormFeedback>
                  )}
                </Col>
                <Col sm={6}>
                  <Label>{algorithmWithSecret.includes(validation.values.jwt_auth_algorithm) ? "Secret" : "Private key"}</Label>
                  <Input
                    id="jwt_auth_secret"
                    name="jwt_auth_secret"
                    type="text"
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.jwt_auth_secret || ""}
                    invalid={
                      validation.touched.jwt_auth_secret && validation.errors.jwt_auth_secret ? true : false
                    }
                    placeholder={algorithmWithSecret.includes(validation.values.jwt_auth_algorithm)
                      ? "Secret key" : "PASTE CONTENTS THAT BEGINS WITH -----BEGIN PRIVATE KEY"}
                  />
                  {validation.touched.jwt_auth_secret && validation.errors.jwt_auth_secret && (
                    <FormFeedback type="invalid">{validation.errors.jwt_auth_secret}</FormFeedback>
                  )}
                </Col>
              </Row>
              : null
            }
            {validation.values.authentication_type === authenticationTypes[4] ? // API Key
              <Row className="mb-3">
                <Col sm={6} className="mb-3">
                  <Label>Key</Label>
                  <Input
                    id="api_key_auth_key"
                    name="api_key_auth_key"
                    type="text"
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.api_key_auth_key || ""}
                    invalid={
                      validation.touched.api_key_auth_key && validation.errors.api_key_auth_key ? true : false
                    }
                    placeholder="Key"
                  />
                  {validation.touched.api_key_auth_key && validation.errors.api_key_auth_key && (
                    <FormFeedback type="invalid">{validation.errors.api_key_auth_key}</FormFeedback>
                  )}
                </Col>
                <Col sm={6} >
                  <Label>Value</Label>
                  <Input
                    id="api_key_auth_value"
                    name="api_key_auth_value"
                    type="text"
                    className="input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.api_key_auth_value || ""}
                    invalid={
                      validation.touched.api_key_auth_value && validation.errors.api_key_auth_value ? true : false
                    }
                    placeholder="Value"
                  />
                  {validation.touched.api_key_auth_key && validation.errors.api_key_auth_key && (
                    <FormFeedback type="invalid">{validation.errors.api_key_auth_key}</FormFeedback>
                  )}
                </Col>
                <Col sm={4}>
                  <Label htmlFor="auth_location">Authentication Location</Label>
                  <Select
                    id="auth_location"
                    name="auth_location"
                    onBlur={validation.handleBlur}
                    value={availableAuthenticationLocation.find(
                      (option) => option.label === validation.values.authentication_location
                    )}
                    placeholder="Authentication Location"
                    onChange={(selectedOption) => {
                      validation.setFieldValue("authentication_location", selectedOption.label);
                    }}
                    options={availableAuthenticationLocation}
                    className="select2-selection col-form-label bg-transparent text-white"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </Col>
              </Row>
              : null
            }
            <Row className="mb-3">
              <Col sm="6">
                <Label>Request Parameters</Label>
                {parameters.map((param, index) => (
                  <div key={index} className="d-flex gap-2 mb-2">
                    <div className="w-50">
                      <Input
                        id={`request_params_${index}_key`}
                        name={`request_params_${index}_key`}
                        type="text"
                        required
                        className="input"
                        value={param.key}
                        onChange={(e) => handleParameterChange(index, 'key', e.target.value)}
                        onBlur={() => handleBlur(index, 'key', 'parameters')}
                        invalid={touched.parameters[index]?.key && validateField(param.key)}
                        placeholder="Key"
                      />
                      {touched.parameters[index]?.key && validateField(param.key) ? (
                        <FormFeedback type="invalid">Key is required</FormFeedback>
                      ) : null}
                    </div>
                    <div className="w-50">
                      <Input
                        id={`request_params_${index}_value`}
                        name={`request_params_${index}_value`}
                        type="text"
                        required
                        className="input"
                        value={param.value}
                        onChange={(e) => handleParameterChange(index, 'value', e.target.value)}
                        onBlur={() => handleBlur(index, 'value', 'parameters')}
                        invalid={touched.parameters[index]?.value && validateField(param.value)}
                        placeholder="Value"
                      />
                      {touched.parameters[index]?.value && validateField(param.value) ? (
                        <FormFeedback type="invalid">Value is required</FormFeedback>
                      ) : null}
                    </div>
                    <div>
                      <Button
                        color="danger"
                        onClick={() => handleDeleteRequestParameter(index)}
                      >
                        <i className="mdi mdi-delete" />
                      </Button>
                    </div>
                  </div>
                ))}
                <div>
                  <Button color="primary" onClick={handleAddRequestParameter}>
                    <i className="mdi mdi-plus" /> Add Request Parameter
                  </Button>
                </div>
              </Col>
              <Col sm="6">
                <Label>Request Headers</Label>
                {headers.map((header, index) => (
                  <div key={index} className="d-flex gap-2 mb-2">
                    <div className="w-50">
                      <Input
                        id={`request_headers_${index}_key`}
                        name={`request_headers_${index}_key`}
                        type="text"
                        required
                        className="input"
                        value={header.key}
                        onChange={(e) => handleHeaderChange(index, 'key', e.target.value)}
                        onBlur={() => handleBlur(index, 'key', 'headers')}
                        invalid={touched.headers[index]?.key && validateField(header.key)}
                        placeholder="Key"
                      />
                      {touched.headers[index]?.key && validateField(header.key) ? (
                        <FormFeedback type="invalid">Key is required</FormFeedback>
                      ) : null}
                    </div>
                    <div className="w-50">
                      <Input
                        id={`request_headers_${index}_value`}
                        name={`request_headers_${index}_value`}
                        type="text"
                        required
                        className="input"
                        value={header.value}
                        onChange={(e) => handleHeaderChange(index, 'value', e.target.value)}
                        onBlur={() => handleBlur(index, 'value', 'headers')}
                        invalid={touched.headers[index]?.value && validateField(header.value)}
                        placeholder="Value"
                      />
                      {touched.headers[index]?.value && validateField(header.value) ? (
                        <FormFeedback type="invalid">Value is required</FormFeedback>
                      ) : null}
                    </div>
                    <div>
                      <Button
                        color="danger"
                        onClick={() => handleDeleteRequestHeader(index)}
                      >
                        <i className="mdi mdi-delete" />
                      </Button>
                    </div>
                  </div>
                ))}
                <div>
                  <Button color="primary" onClick={handleAddRequestHeader}>
                    <i className="mdi mdi-plus" /> Add Request Header
                  </Button>
                </div>
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col sm='6'>
                <div className="mb-3 my-2">
                  <Label htmlFor="name">Response Check Type</Label>
                  <Select
                    id="response_check_type"
                    name="response_check_type"
                    onBlur={validation.handleBlur}
                    value={responseCheckTypeOptions.find(
                      (option) => option.label === validation.values.response_check_type
                    )}
                    placeholder="Response Check Type"
                    onChange={(selectedOption) => {
                      validation.setFieldValue("response_check_type", selectedOption.label);
                    }}
                    options={responseCheckTypeOptions}
                    className="select2-selection bg-transparent text-white mb-2"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </div>
                <div className="mb-3 my-2">
                  <Label className="form-label">Response Body</Label>
                  <textarea
                    name="response_body"
                    value={validation.values.response_body || ''}
                    style={{fontFamily: 'monospace'}}
                    placeholder= {validation.values.response_check_type === 'REGEX' ? "Enter regex for parsing the output" : "Enter Response Body in JSON Format"}
                    onChange={(event) => {
                      const userInput = event.target.value;
                      if(validation.values.response_check_type !== "REGEX") {
                        validation.setFieldValue("response_body", handleJsonChange(userInput));
                      } else {
                        validation.setFieldValue("response_body", userInput);
                        setTestDataValid(null)
                        setRegexVerified(null)
                      }
                    }}
                    onBlur={(e) => {
                      if(validation.values.response_check_type !== "REGEX") {
                        validation.setFieldValue('response_body', lintJson(validation.values.response_body));
                      }
                      validation.handleBlur(e);
                    }}
                    rows={10}
                    className={
                      validation.touched.response_body &&
                      validation.errors.response_body
                        ? 'form-control is-invalid'
                        : validation.values.response_check_type !== "REGEX" ||
                        validation.values.response_body == "" ||  regexVerified === null
                          ? 'form-control'
                          : regexVerified ? 'form-control is-valid' : 'form-control is-invalid'
                    }
                  />
                  {validation.touched.response_body &&
                  validation.errors.response_body ? (
                    <FormFeedback type="invalid">
                      {validation.errors.response_body}
                    </FormFeedback>
                  ) : null}
                </div>
                {validation.values.response_check_type === 'REGEX' ?
                  <div className="mb-3 my-2">
                    <Label htmlFor="name">Test JSON</Label>
                    <textarea
                      name="test_json_for_regex"
                      value={validation.values.test_json_for_regex || ''}
                      style={{fontFamily: 'monospace'}}
                      placeholder="Enter a sample JSON to test your regex"
                      onChange={(event) => {
                        const userInput = event.target.value;
                        validation.setFieldValue("test_json_for_regex", handleJsonChange(userInput));
                        setTestDataValid(null)
                        setRegexVerified(null)
                      }}
                      onBlur={(e) => {
                        validation.setFieldValue('test_json_for_regex', lintJson(validation.values.test_json_for_regex));
                        validation.handleBlur(e);
                      }}
                      rows={10}
                      className={
                        validation.touched.test_json_for_regex &&
                        validation.errors.test_json_for_regex
                          ? 'form-control is-invalid'
                          : validation.values.response_check_type !== "REGEX" ||
                          validation.values.test_json_for_regex == "" || testDataValid === null
                            ? 'form-control'
                            : testDataValid ? 'form-control is-valid' : 'form-control is-invalid'
                      }
                    />
                    {validation.touched.test_json_for_regex && validation.errors.test_json_for_regex ? (
                      <FormFeedback type="invalid">{validation.errors.test_json_for_regex}</FormFeedback>
                    ) : null}
                    {regexValidating ?
                      <div className='mt-2'>
                        <Spinner className="ms-2" color="primary"/>
                      </div> :
                      <button
                        className="btn btn-primary mt-2"
                        onClick={handleTestRegex}
                      >
                        Test Regex
                      </button>
                    }
                  </div>: null
                }
              </Col>
              {methodOptionsWithBody.includes(validation.values.request_method) ?
                <Col sm='6'>
                  <div className="mb-3 my-2 invisible">
                    <Label htmlFor="name">Response Check Type</Label>
                    <Select
                      id="response_check_type"
                      name="response_check_type"
                      onBlur={validation.handleBlur}
                      value={responseCheckTypeOptions.find(
                        (option) => option.label === validation.values.response_check_type
                      )}
                      placeholder="Response Check Type"
                      onChange={(selectedOption) => {
                        validation.setFieldValue("response_check_type", selectedOption.label);
                      }}
                      options={responseCheckTypeOptions}
                      className="select2-selection bg-transparent text-white mb-2"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          neutral0: '#222736',
                          neutral5: '#485EC4',
                          neutral10: '#485EC4',
                          neutral60: '#ffffff',
                          neutral70: '#ffffff',
                          neutral80: '#ffffff',
                          neutral90: '#ffffff',
                          primary: '#485EC4',
                        },
                      })}
                      styles={customStyles}
                    />
                  </div>
                  <Label className="form-label">Request Body</Label>
                  <textarea
                    style={{fontFamily: 'monospace'}}
                    name="request_body"
                    value={validation.values.request_body || ''}
                    placeholder="Enter Request Body in JSON Format"
                    onChange={(event) => {
                              const userInput = event.target.value;
                              validation.setFieldValue("request_body", handleJsonChange(userInput));
                            }}
                    onBlur={validation.handleBlur}
                    rows={10}
                    className={
                      validation.touched.request_body &&
                      validation.errors.request_body
                        ? 'form-control is-invalid'
                        : 'form-control'
                    }
                  />
                  {validation.touched.request_body &&
                  validation.errors.request_body ? (
                    <FormFeedback type="invalid">
                      {validation.errors.request_body}
                    </FormFeedback>
                  ) : null}
                </Col> : null
              }
            </Row>
            </Col>
            <Col sm={5}>
             <Row>
             <Label htmlFor="alarm_setting">Alarm Setting</Label>
              <Col sm="12" >
                <div className="d-flex align-items-center">
                  <Label htmlFor="failure_count_alert" className="me-2 mt-2">
                    Alarm on
                  </Label>
                  <div className="d-flex flex-column me-2">
                    <Input
                      id="failure_count_alert"
                      name="failure_count_alert"
                      type="number"
                      required
                      className="input"
                      style={{ width: "80px" }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.failure_count_alert !== undefined && validation.values.failure_count_alert !== null ? validation.values.failure_count_alert : ""}
                      invalid={
                        validation.touched.failure_count_alert && validation.errors.failure_count_alert ? true : false
                      }
                      placeholder="Y"
                    />
                  </div>
                  <Label htmlFor="number_of_checks" className="me-2 mt-2">
                    Failures out of
                  </Label>
                  <div className="d-flex flex-column me-2">
                    <Input
                      id="number_of_checks"
                      name="number_of_checks"
                      type="number"
                      required
                      className="input"
                      style={{ width: "80px" }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.number_of_checks !== undefined && validation.values.number_of_checks !== null ? validation.values.number_of_checks : ""}
                      invalid={
                        validation.touched.number_of_checks && validation.errors.number_of_checks ? true : false
                      }
                      placeholder="X"
                    />
                  </div>
                  <Label htmlFor="checks" className=" mt-2">
                    Checks
                  </Label>
                  <div className='mb-2'>
                    <span
                      id="TooltipNumberCheck"
                      onMouseOver={() => setToolTipNumberCheck(true)}
                      onMouseLeave={() => setToolTipNumberCheck(false)}
                      className="alert-icon">
                      <i className="mdi mdi-information-outline text-warning mb-1" />
                    </span>
                  </div>
                  <Tooltip
                    placement="right"
                    isOpen={tooltipNumberCheck}
                    target="TooltipNumberCheck"
                    toggle={() => { setToolTipNumberCheck(!tooltipNumberCheck); }}
                    style={{
                      border: "2px solid #f1b44c",
                      borderRadius: "15px",
                      backgroundColor: "#2a3042",
                      zIndex: 1,
                      width: "200px",
                      padding: "10px",
                      marginBottom:"20px"
                    }}
                  >
                    <div style={{color: "#f1b44c", fontSize: "12px", lineHeight: "1.5"}}>
                      <strong>We suggest</strong>
                      <table className={"w-100"} style={{textAlign: "left"}}>
                        <tbody>
                        <tr>
                          <td className="pr-2">Check Interval</td>
                          <td className="px-2">X</td>
                          <td className="pl-2">Y</td>
                        </tr>
                        <tr>
                          <td className="pr-2">1-5 mins</td>
                          <td className="px-2">3</td>
                          <td className="pl-2">5</td>
                        </tr>
                        <tr>
                          <td className="pr-2">5-15 mins</td>
                          <td className="px-2">2</td>
                          <td className="pl-2">3</td>
                        </tr>
                        <tr>
                          <td className="pr-2">Above 15 mins</td>
                          <td className="px-2">1</td>
                          <td className="pl-2">1</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </Tooltip>
                </div>
              </Col>
              <Col sm="5">
                <div className='mb-3'>
                {validation.touched.failure_count_alert && validation.errors.failure_count_alert && (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.failure_count_alert}
                        </FormFeedback>
                      )}
                </div>
              </Col>
              <Col sm="5">
                <div className='mb-3'>
                {validation.touched.number_of_checks && validation.errors.number_of_checks && (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.number_of_checks}
                        </FormFeedback>
                      )}
                </div>
              </Col>
              <Col sm="12">
                { !validation.errors.check_interval && !validation.errors.failure_count_alert &&
                  validation.values.check_interval && validation.values.failure_count_alert && (
                  <div className="alert alert-success p-2" role="alert">
                    Alert will be raised
                    {` ${validation.values.check_interval * (validation.values.failure_count_alert - 1)}`} minutes
                    after the first failure
                  </div>
                  )
                }
              </Col>
             </Row>
            </Col>
          </Row>
          <Row>
              <div className='d-flex align-items-center justify-content-end gap-4'>
                <div className='d-flex justify-content-end'>
                  <Link
                    id='deleteTooltip'
                    className="mx-auto text-secondary"
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      pingMonitorDetail.id,
                      handleEndpointDeleteModal();
                    }}>
                    <i className="mdi font-size-24 mdi-delete deleteUserIcon text-danger" id={`deletetooltip`}></i>
                  </Link>
                  <UncontrolledTooltip placement='top' target={'deleteTooltip'}>Delete Endpoint</UncontrolledTooltip>
                </div>
                <div className="text-end">
                  <button
                    type="submit"
                    className="btn btn-success save-user"
                  >
                    Update
                  </button>
                </div>
              </div>
          </Row>
          </Form>
        </ModalBody>
      </div>
        {EndpointForDelete && (<Modal
          isOpen={EndpointDeleteModal}
          role="dialog"
          autoFocus={true}
          keyboard={false}
          centered
          backdrop="static"
          data-toggle="modal"
        >
          <ModalHeader className="border-bottom-2">
            Delete this Endpoint?
          </ModalHeader>
          <ModalBody>
            <div className="mb-2"><b>Name:</b> {EndpointForDelete.name}</div>
            <div className="mb-4"><b>Endpoint:</b> {EndpointForDelete.url.length > 50 ? EndpointForDelete.url.slice(0,50) + "..." :EndpointForDelete.url }</div>
            <div className="row text-center">
              <Col lg="6">
                <Link onClick={cancelUserDeleteModal} className="btn btn-secondary w-md">Cancel</Link>
              </Col>
              <Col lg="6">
                <Link
                  className="btn btn-danger w-md"
                  onClick={() => {
                    handleEndpointDelete(EndpointForDelete.id);
                  }}
                >
                  Confirm
                </Link>
              </Col>
            </div>
          </ModalBody>
        </Modal>)}
      </div>
    </Modal>
  )
}
OnEditModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  serviceId: PropTypes.any
}

export default OnEditModal